import React from 'react'
import { Avatar as MantineAvatar, AvatarProps as MantineAvatarProps } from '@mantine/core'
import placeholder from '@/assets/images/placeholders/avatar.svg'

export interface AvatarProps extends MantineAvatarProps {
  src?: string
  children?: React.ReactNode
  className?: string
}

export const Avatar: React.FC<AvatarProps> = ({ src, children, className, ...props }) => {
  const noImage = !src && !children

  return (
    <MantineAvatar src={noImage ? placeholder : src} {...props}>
      {children}
    </MantineAvatar>
  )
}
